import { render } from "./usersEditor.vue?vue&type=template&id=49e2725e"
import script from "./usersEditor.vue?vue&type=script&lang=js"
export * from "./usersEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__